module.exports = {"general":{"ssm_number":"BRN (Business Registration Number)"}};